export enum HouseBillingAccountStatus {
    Active = 'Active',
    Collections = 'Collections',
    Deleted = 'Deleted',
    Delinquent = 'Delinquent',
    Inactive = 'Inactive',
    LimitedAccess = 'Limited Access',
    RequiresUpdatedPaymentInfo = 'Requires Updated Payment Info',
    Unavailable = '',
}

export type HouseBillingStatus = {
    accountStatus: HouseBillingAccountStatus;
    balance: number;
    /**
     * The currency that the house uses for billing purposes with LiveAuctioneers.
     * If a currency is not available, the value will be `NOT SET`
     */
    currency: string | 'NOT SET';
    houseId: number;
    name: string;
};

export type HouseBillingStatusSlice = {
    byId: {
        [houseId: number]: HouseBillingStatus;
    };
    isSaving: boolean;
    loading: number[];
};

export const defaultHouseBillingStatusSlice = {
    byId: {},
    isSaving: false,
    loading: [],
};
